(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sites/table_view', {
            templateUrl: 'partials/openbase/sites_table_view.html',
            controller: OpenbaseSitesController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifOpenbaseSiteService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }


    function OpenbaseSitesController($scope, openbase, data) {
        'ngInject';
        $scope.sites = data.sites;
        $scope.callback = openbase.site.callback;
        $scope.preValidate = openbase.site.preValidate;
        $scope.preModal = openbase.site.preModal;
    }


})();
